import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import styled from 'styled-components';
import Tornado from './Tornado';

const AnimationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow: hidden;
`;

const LogoContainer = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
`;

const LogoImage = styled(motion.img)`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const AnimatedLogos = ({ logo1, logo2, tornadoColor, durations }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [isFirstCycle, setIsFirstCycle] = useState(true);

  // Ciclo de animación
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentStep((prev) => {
        if (prev === durations.length - 1) {
          setIsFirstCycle(false);
        }
        return (prev + 1) % durations.length;
      });
    }, durations[currentStep]);

    return () => clearInterval(interval);
  }, [currentStep, durations]);

  const variants = {
    enter: { opacity: 0, scale: 0.5, transition: { duration: 1 } },
    center: { opacity: 1, scale: 1, transition: { duration: 1 } },
    exit: { opacity: 0, scale: 0.5, transition: { duration: 1 } },
  };

  return (
    <AnimationContainer>
      <AnimatePresence mode="sync">
        {currentStep === 0 && (
          <LogoContainer key="logo1">
            <LogoImage
              src={logo1}
              alt="Logo 1"
              initial={isFirstCycle ? false : 'enter'}
              animate="center"
              exit="exit"
              variants={variants}
            />
          </LogoContainer>
        )}
        {currentStep === 1 && (
          <motion.div key="tornado1" initial="enter" animate="center" exit="exit">
            <Tornado color={tornadoColor} />
          </motion.div>
        )}
        {currentStep === 2 && (
          <LogoContainer key="logo2">
            <LogoImage
              src={logo2}
              alt="Logo 2"
              initial="enter"
              animate="center"
              exit="exit"
              variants={variants}
            />
          </LogoContainer>
        )}
        {currentStep === 3 && (
          <motion.div key="tornado2" initial="enter" animate="center" exit="exit">
            <Tornado color={tornadoColor} />
          </motion.div>
        )}
      </AnimatePresence>
    </AnimationContainer>
  );
};

export default AnimatedLogos;